import SourceIndexVue from "@/views/source/SourceIndex.vue";

const source = [
  {
    path: "/source",
    name: "source",
    component: SourceIndexVue,
    meta: {
      layout: "default",
      role: ["superadmin","backoffice"],
      public: false,
    },
  },
];

export default source;
